module.exports = {"370215001":"环秀街道","370215002":"潮海街道","370215003":"通济街道","370215004":"北安街道","370215005":"龙山街道","370215006":"龙泉街道","370215007":"鳌山卫街道","370215008":"温泉街道","370215009":"灵山街道","370215010":"蓝村街道","370215011":"大信街道","370215100":"田横镇","370215101":"金口镇","370215103":"段泊岚镇","370215104":"移风店镇","370215400":"通济新经济区","370215402":"田横岛省级旅游度假区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370215.json
// module id = 1487
// module chunks = 0